var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Modal",
    {
      class: { footer: _vm.footer },
      attrs: { overlay: _vm.overlay, clickOverlayClose: _vm.clickOverlayClose },
      on: { close: _vm.close }
    },
    [
      _c(
        "div",
        { staticClass: "component-dialog", class: _vm.computedClass },
        [
          _vm.iClose
            ? _c("Close", {
                attrs: { className: "i-close" },
                on: { click: _vm.close }
              })
            : _vm._e(),
          _c("p", { staticClass: "dialog-title bold h2 color-gray-1" }, [
            _vm._v(_vm._s(_vm.title))
          ]),
          _c(
            "div",
            { staticClass: "dialog-content color-gray-2 text1" },
            [
              _c("p", {
                staticClass: "content-text",
                domProps: { innerHTML: _vm._s(_vm.content) }
              }),
              _vm._t("content")
            ],
            2
          ),
          _vm._t("default"),
          _vm._t("footer")
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }